import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FHIRObservation } from '../../../../models';

@Component({
  selector: 'app-observations-section',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './observations-section.component.html',
})
export class ObservationsSectionComponent {
  readonly observations = input.required<FHIRObservation[]>();

  formatDate(date: string): string {
    if (!date) return '—';
    return /^\d{4}-\d{2}-\d{2}/.test(date) ? date.slice(0, 10) : date;
  }

  getStatusBadge(status: string): { color: string; label: string } {
    const s = (status || '').toLowerCase();
    if (s === 'final') return { color: 'bg-success', label: 'Final' };
    if (s === 'preliminary') return { color: 'bg-warning text-dark', label: 'Preliminar' };
    if (s === 'registered') return { color: 'bg-info', label: 'Registrado' };
    if (s === 'cancelled') return { color: 'bg-danger', label: 'Cancelado' };
    if (s === 'amended') return { color: 'bg-primary', label: 'Enmendado' };
    if (s === 'corrected') return { color: 'bg-primary', label: 'Corregido' };
    if (s === 'entered-in-error') return { color: 'bg-danger', label: 'Error de Entrada' };
    if (s === 'unknown') return { color: 'bg-secondary', label: 'Desconocido' };
    return { color: 'bg-secondary', label: status || '—' };
  }

  getObsName(obs: FHIRObservation): string {
    return obs.code?.text || obs.code?.coding?.[0]?.display || '—';
  }

  getObsCode(obs: FHIRObservation): string {
    return obs.code?.coding?.[0]?.code || '';
  }

  getObsValue(obs: FHIRObservation): string {
    if (obs.valueQuantity) {
      return `${obs.valueQuantity.value ?? ''} ${obs.valueQuantity.unit ?? ''}`.trim();
    }
    if (obs.valueCodeableConcept) {
      return obs.valueCodeableConcept.text || obs.valueCodeableConcept.coding?.[0]?.display || '';
    }
    if (obs.valueString) return obs.valueString;
    return '—';
  }

  getEffectiveDate(obs: FHIRObservation): string {
    return obs.effectiveDateTime || obs.effectivePeriod?.start || obs.issued || '';
  }

  getCategory(obs: FHIRObservation): string {
    return (
      obs.category?.[0]?.coding?.[0]?.display ||
      obs.category?.[0]?.coding?.[0]?.code ||
      obs.category?.[0]?.text ||
      ''
    );
  }
}
